import { ArrowUp, Instagram } from "lucide-react";
import { Logo } from "@/components/Logo";
import { scrollToId } from "@/lib/scroll";

const NAV = [
    { label: "Services", id: "services" },
    { label: "Portfolio", id: "portfolio" },
    { label: "Service Area", id: "area" },
    { label: "Project Inquiry", id: "inquiry" },
];

export const Footer = () => (
    <footer className="relative overflow-hidden bg-espresso text-bone">
        <div className="mx-auto max-w-7xl px-4 pb-10 pt-20 sm:px-6 md:pt-28 lg:px-8">
            <div className="flex flex-col gap-14 border-b border-bone/10 pb-14 lg:flex-row lg:items-start lg:justify-between">
                <div className="max-w-xl">
                    <h2 className="font-serif text-4xl font-light leading-[1.05] tracking-tight sm:text-5xl md:text-6xl">
                        Steevens
                        <br />
                        <span className="italic text-wood">Complete Interiors</span>
                    </h2>
                    <p className="mt-6 flex items-center gap-2 font-mono text-[11px] uppercase tracking-[0.22em] text-bone/60">
                        <span className="h-1.5 w-1.5 rotate-45 bg-oak" />
                        Drywall · Paint · Tile &amp; Marble · Flooring
                    </p>
                    <a
                        data-testid="footer-instagram-link"
                        href="https://www.instagram.com/steevens_services/"
                        target="_blank"
                        rel="noopener noreferrer"
                        aria-label="Steevens Complete Interiors on Instagram"
                        className="group mt-8 inline-flex items-center gap-3 border border-bone/20 px-5 py-3 transition-colors hover:border-wood hover:bg-wood hover:text-espresso"
                    >
                        <Instagram className="h-4 w-4 text-wood transition-colors group-hover:text-espresso" />
                        <span className="font-mono text-[11px] uppercase tracking-[0.18em] text-bone transition-colors group-hover:text-espresso">
                            @steevens_services
                        </span>
                    </a>
                </div>

                <div className="flex gap-16 md:gap-24">
                    <nav className="flex flex-col gap-3">
                        <p className="font-mono text-[10px] uppercase tracking-[0.24em] text-bone/40">Explore</p>
                        {NAV.map((l) => (
                            <button
                                key={l.id}
                                data-testid={`footer-link-${l.id}`}
                                onClick={() => scrollToId(l.id)}
                                className="text-left text-sm text-bone/75 transition-colors hover:text-wood"
                            >
                                {l.label}
                            </button>
                        ))}
                    </nav>
                    <div className="flex flex-col gap-3">
                        <p className="font-mono text-[10px] uppercase tracking-[0.24em] text-bone/40">Service area</p>
                        <p className="text-sm leading-relaxed text-bone/75">
                            Broward County
                            <br />
                            Palm Beach County
                            <br />
                            South Florida
                        </p>
                    </div>
                </div>
            </div>

            <div className="flex flex-col gap-6 pt-8 sm:flex-row sm:items-center sm:justify-between">
                <div className="flex items-center gap-3">
                    <Logo dark className="h-8 w-8" />
                    <p className="font-mono text-[10px] uppercase tracking-[0.2em] text-bone/50">
                        © {new Date().getFullYear()} Steevens Complete Interiors — Serving Broward &amp; Palm Beach Counties
                    </p>
                </div>
                <button
                    data-testid="footer-back-to-top"
                    onClick={() => scrollToId("top")}
                    aria-label="Back to top"
                    className="group flex h-12 w-12 items-center justify-center border border-bone/20 text-bone transition-colors hover:border-wood hover:bg-wood hover:text-espresso"
                >
                    <ArrowUp className="h-5 w-5 transition-transform duration-300 group-hover:-translate-y-0.5" />
                </button>
            </div>
        </div>
    </footer>
);
